import { render } from "./T_shirt_8_back.vue?vue&type=template&id=fc6120f0"
import script from "./T_shirt_8_back.vue?vue&type=script&lang=js"
export * from "./T_shirt_8_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__